import { Component, Input } from '@angular/core';
import { AlertService } from '@core/services/alert.service';
import { PolicyService } from '@core/services/policy.service';
import { TravelMemberService } from '@core/services/travel-member.service';
import { MaInsuranceTravel } from '@shared/models/ma-insurance';
import { InsuredTripTravelCardRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-request';
import { InsuredTripTravelCardRequestMultiple } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-request-multiple';
import { InsuredTripTravelCardResponse } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-response';
import { Policy } from '@shared/models/policy';
import moment from 'moment';

@Component({
    selector: 'app-travel-card',
    templateUrl: './travel-card.component.html',
    styleUrls: ['./travel-card.component.scss'],
    standalone: false
})

export class TravelCardComponent {
    @Input() policy: Policy;
    @Input() maInsurance: MaInsuranceTravel
    @Input() policyState: string;

    constructor(
        private policyService: PolicyService,
        private travelMemberService: TravelMemberService, // refactor
        private alertService: AlertService
    ) {}

    generateTravelCard() {

        if (!this.maInsurance.insuredPerson) {
            this.alertService.warn('Neplatné dáta');
            return;
        }

        let insuredTripTravelCardRequestMultiple = new InsuredTripTravelCardRequestMultiple();
        this.maInsurance.insuredPerson.forEach(insuredPerson => {
            let insuredTripTravelCardRequest = new InsuredTripTravelCardRequest();

            insuredTripTravelCardRequest.policyNumber = this.policy.policyNumber;
            insuredTripTravelCardRequest.dateBegin = moment(this.policy.beginDate).format('DD.MM.YYYY');
            insuredTripTravelCardRequest.dateEnd = moment(this.policy.endDate).format('DD.MM.YYYY');

            insuredTripTravelCardRequest.firstName = insuredPerson.firstName;
            insuredTripTravelCardRequest.surname = insuredPerson.surname;
            insuredTripTravelCardRequest.dateOfBirth = moment(insuredPerson.dateOfBirth).format('DD.MM.YYYY');

            insuredTripTravelCardRequestMultiple.travelInsuranceMembers.push(insuredTripTravelCardRequest);
        });

        this.policyService.generateTravelCard(insuredTripTravelCardRequestMultiple).subscribe((insuredTripTravelCardResponse: InsuredTripTravelCardResponse) => {
            this.travelMemberService.getTravelCart(insuredTripTravelCardResponse.uuid);
        });
    }
}
